// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9b4ce011","239":"3234e5b5","732":"af563fb8","864":"7299bd84"}[chunkId] + ".chunk.js";
};